import { render } from "./DashboardDesktop.vue?vue&type=template&id=6b94cfbb&scoped=true"
import script from "./DashboardDesktop.vue?vue&type=script&lang=js"
export * from "./DashboardDesktop.vue?vue&type=script&lang=js"

import "./DashboardDesktop.vue?vue&type=style&index=0&id=6b94cfbb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b94cfbb"]])

export default __exports__